import AdtInfoTitleExportPanel from "./adtInfoTitleExportPanel.container";

export default AdtInfoTitleExportPanel;
